import axios from "axios";

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:5050";

export const ASSET_BASE_URL = import.meta.env.DEV
  ? "http://localhost:5050/api"
  : "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export default api;
